import { useState } from 'react';

export type ColorType = {
  id: string;
  value: string;
  name: string;
  lightValue: string;
  lightName: string;
};

const useNewColors = (): ColorsContext => {
  const [colors] = useState<ColorType[]>([
    {
      id: 'red',
      value: '#FF4444',
      name: 'Alert Red',
      lightValue: '#FFDADA',
      lightName: 'alertRedMild',
    },
    {
      id: 'orange',
      value: '#FC7F5B',
      name: 'Orange',
      lightValue: '#FFECE6',
      lightName: 'orangeMild',
    },
    {
      id: 'yellow',
      value: '#FBBD42',
      name: 'Yellow',
      lightValue: '#FDF4E0',
      lightName: 'yellowVividMild',
    },
    {
      id: 'secondaryGreen',
      value: '#18A87D',
      name: 'Secondary Green',
      lightValue: '#DCF2EC',
      lightName: 'greenSecondaryMild',
    },
    {
      id: 'green',
      value: '#035B60',
      name: 'Dark Green',
      lightValue: '#DCF2EC',
      lightName: 'greenSecondaryMild',
    },
    {
      id: 'blue',
      value: '#138EFF',
      name: 'Blue',
      lightValue: '#DCEEFF',
      lightName: 'blueMild',
    },
    {
      id: 'purple',
      value: '#7B61FF',
      name: 'Purple',
      lightValue: '#EBE7FF',
      lightName: 'purpleMild',
    },
    {
      id: 'lightMagenta',
      value: '#C072CD',
      name: 'Light Magenta',
      lightValue: '#F6EAF8',
      lightName: 'magentaLight',
    },
    {
      id: 'magenta',
      value: '#A620B2',
      name: 'Dark Magenta',
      lightValue: '#F6EAF8',
      lightName: 'magentaLight',
    },
  ]);
  const getComputedColor = (label: string): ColorType => {
    if (!label) return colors[1];

    if (label.length > 1) {
      const firstCharacters = label.substring(0, 2).toUpperCase();
      const i = firstCharacters.toUpperCase().charCodeAt(0) - 65 || 0;
      const h = firstCharacters.toUpperCase().charCodeAt(1) - 65 || 0;

      const color = colors[Math.floor(Math.floor((i + h) / 2) % colors.length)];

      if (!color) return colors[1];

      return color;
    }

    const i = label.toUpperCase().charCodeAt(0) - 65 || 0;

    const color = colors[Math.floor(Math.floor((i + 0) / 2) % colors.length)];

    if (!color) return colors[1];

    return color;
  };

  const getMappedColor = (color: string) => {
    const colorFound = colors?.find((c: ColorType) => c.id === color);

    return colorFound ? colorFound.value : colors[0].value;
  };

  const getMappedLightColor = (color: string) => {
    const colorFound = colors?.find((c: ColorType) => c.id === color);

    return colorFound ? colorFound.lightValue : colors[0].lightValue;
  };

  return {
    colors,
    getMappedColor,
    getComputedColor,
    getMappedLightColor,
  };
};

export default useNewColors;
